<div class="dialog-box">
    <!-- header modal -->
    <div class="d-flex justify-content-start align-items-center">
        <div class="col-12 p-0 d-flex align-items-center justify-content-between border-bottom">
            <p class="design-modal-title mb-2">
                {{ 'app.image-cropper.title' | translate }}
            </p>
            <span class="cursor-pointer" (click)="dialogRef.close()"><i class="fa-solid fa-x"></i></span>
        </div>
    </div>

    <!-- body modal -->
    <div class="d-flex flex-column-reverse flex-md-row-reverse">
        <div
            class="col-12 col-md-8 d-flex flex-column align-items-center p-3 image-cropper-container position-relative"
        >
            <div class="d-flex justify-content-md-center container-actions mb-4 w-100">
                <div class="d-flex align-items-center cursor-pointer" (click)="cropperAction('reset')">
                    <i class="fa-light fa-clock-rotate-left mr-2 action-button"> </i>
                    <p class="m-0">{{ 'app.image-cropper.actions.reset' | translate }}</p>
                </div>
                <div class="save-button">
                    <button class="btn btn-continue" (click)="confirm()">
                        {{ 'app.image-cropper.buttons.accept' | translate }}
                    </button>
                    <!-- <app-ss-button  [class]="'btn btn-continue'" [text]="'app.image-cropper.buttons.accept' | translate" (click)="confirm()"> </app-ss-button> -->
                </div>
            </div>
            <angular-cropper
                #angularCropper
                id="angularCropper"
                [cropperOptions]="cropperSettings"
                [imageUrl]="data.file.src"
            >
            </angular-cropper>
        </div>

        <!-- Cropper action buttons -->
        <div
            class="col-12 col-md-4 d-flex flex-md-column py-3 pl-0 border-md-right flex-wrap justify-content-between justify-content-md-start actions-box"
        >
            <h5 class="w-100 mb-3 d-none d-md-block">{{ 'app.image-cropper.subtitle' | translate }}</h5>

            <!-- Flip -->
            <div class="d-flex flex-column mb-4 mx-2 mx-md-0">
                <h6>{{ 'app.image-cropper.flip' | translate }}</h6>
                <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="cropperAction('rotate-right')">
                    <i class="fa-light fa-reflect-vertical mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.flip-y' | translate }}</p>
                </div>
                <div class="d-flex align-items-center cursor-pointer" (click)="cropperAction('rotate-left')">
                    <i class="fa-light fa-reflect-horizontal mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.flip-x' | translate }}</p>
                </div>
            </div>

            <!-- Rotate -->
            <div class="d-flex flex-column mb-4 mx-2 mx-md-0">
                <h6>{{ 'app.image-cropper.rotate' | translate }}</h6>
                <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="cropperAction('flip-y')">
                    <i class="fa-light fa-rotate-left mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.rotate-left' | translate }}</p>
                </div>
                <div class="d-flex align-items-center cursor-pointer" (click)="cropperAction('flip-x')">
                    <i class="fa-light fa-rotate-right mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.rotate-right' | translate }}</p>
                </div>
            </div>

            <!-- Zoom -->
            <div class="d-flex flex-column mb-4 mx-2 mx-md-0">
                <h6>{{ 'app.image-cropper.zoom' | translate }}</h6>
                <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="cropperAction('zoom-in')">
                    <i class="fa-light fa-magnifying-glass-plus mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.zoom-in' | translate }}</p>
                </div>
                <div class="d-flex align-items-center cursor-pointer" (click)="cropperAction('zoom-out')">
                    <i class="fa-light fa-magnifying-glass-minus mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.zoom-out' | translate }}</p>
                </div>
            </div>

            <!-- Move -->
            <div class="d-flex flex-column mb-4 mx-2 mx-md-0">
                <h6>{{ 'app.image-cropper.move' | translate }}</h6>
                <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="cropperAction('move-left')">
                    <i class="fa-light fa-arrow-left mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.move-left' | translate }}</p>
                </div>
                <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="cropperAction('move-right')">
                    <i class="fa-light fa-arrow-right mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.move-right' | translate }}</p>
                </div>
                <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="cropperAction('move-up')">
                    <i class="fa-light fa-arrow-up mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.move-up' | translate }}</p>
                </div>
                <div class="d-flex align-items-center cursor-pointer" (click)="cropperAction('move-down')">
                    <i class="fa-light fa-arrow-down mr-2 action-button"> </i>
                    <p class="mb-0">{{ 'app.image-cropper.actions.move-down' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
